import { Icon, type IconName } from './icons/Icon'

export type StatusPillVariant = 'success' | 'info' | 'warning' | 'danger' | 'neutral' | 'muted'

const ICON_BY_VARIANT: Record<StatusPillVariant, IconName> = {
  success: 'check-circle',
  info: 'info',
  warning: 'alert-triangle',
  danger: 'alert-circle',
  neutral: 'minus-circle',
  muted: 'archive',
}

export interface StatusPillProps {
  variant: StatusPillVariant
  label: string
  icon?: IconName
}

/**
 * Status conveyed by icon + text, never color alone (design-system.md §2.3 /
 * §7). Reused by every list's Status column.
 */
export function StatusPill({ variant, label, icon }: StatusPillProps) {
  return (
    <span className={`iw-pill iw-pill--${variant}`}>
      <Icon name={icon ?? ICON_BY_VARIANT[variant]} size={12} />
      {label}
    </span>
  )
}
